import { ButtonLink } from './ButtonLink';
import { Section } from './Section';
import './ClosingCtaSection.css';

export function ClosingCtaSection() {
  return (
    <Section id="contact" tone="surface" className="closing-cta-section">
      <div className="closing-cta-section__content">
        <h2>Build the next layer of your enterprise</h2>
        <p>
          Explore how your existing ERP systems, people, processes, and operational data can become
          the foundation for a continuously intelligent enterprise.
        </p>
        <p>
          <strong>For seafood exporters, technology partners, and ecosystem institutions.</strong>
        </p>
        <ButtonLink href="#contact">Request a conversation</ButtonLink>
      </div>
    </Section>
  );
}
